import styled from 'styled-components'
import { Input } from 'components/common/FormElements/Input'
import Mixin from 'components/common/Mixin'

export default styled(Input)`
  margin-right: 10px;
  vertical-align: middle;
  padding-bottom: 15px;
  ${Mixin.responsive('width', '233px', '189px')}
`
